import React, {useState} from "react";
import { useVsiAppContext} from "../../../stores/VsiApp";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {VsiBubble} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {moneyFormatter} from "../../../utils/gridFormatters";
import {useNavigate} from "react-router-dom";
import {DeleteAuth} from "../../../utils/Verbs";
import swal from "sweetalert";
import {Button, Modal, ModalFooter, ModalHeader} from "reactstrap";

const colDefs = [
    {
        "field": "notes",
        "headerName": "Project Note",
        "enableRowGroup": true,
    },
    {
        "field": "type",
        "headerName": "Type",
        "enableRowGroup": true,
    },
    {
        "field": "name",
        "headerName": "Target",
        "enableRowGroup": true,
    },
    {
        "field": "unit",
        "headerName": "Unit",
        "enableRowGroup": true,
    },
    {
        "field": "secondUnit",
        "headerName": "Secondary Unit",
        "enableRowGroup": true,
    },
    {
        "field": "date",
        "headerName": "Date",
        "enableRowGroup": true,
    },
    {
        "field": "cost",
        "headerName": "Cost",
        "cellRenderer": moneyFormatter,
        "enableRowGroup": true,
    },
    {
        "field": "changes",
        "headerName": "Changes",
        "enableRowGroup": true,
    },
    {
        "field": "changedByUserEmail",
        "headerName": "Made By",
        "enableRowGroup": true,
    },
]
export default function PlanningProjects({title, context}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { client, periodId, getAccessTokenSilently } = useVsiAppContext();

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [rowSelected, setRowSelected] = useState(null);
    const [rowDeleted, setRowDeleted] = useState(undefined);
    const [data] = useDataWithRoute(`/api/v6/admin/capacity_projects/${client.clientId}`, rowDeleted);
    let navigate = useNavigate();
    const rowDoubleClicked = (e) => {
        const {type, name} = e.data;

        if (type === "Device") {
            navigate(`/reports/storage/device/device-capacity-plan?device_name=${encodeURI(name)}&period_id=${periodId}`);
        } else if (type === "Pool") {
            const parsedDev = name.split(" - ");
            const [device, pool] = parsedDev;

            navigate(`/reports/storage/device/pool-capacity-plan?device_name=${encodeURI(device)}&pool_name=${pool}&period_id=${periodId}`);
        } else if (type.includes('Enterprise')) {
            const {unit, unitName, secondUnit, secondUnitName} = e.data;
            let route = `/reports/storage/enterprise-capacity-plan?unit=${unit}`;
            if (unitName) {
                route = route + `&${unit}=${unitName.trim()}`
            }
            if (secondUnit) {
                route = route + `&secondaryUnit=${secondUnit}&${secondUnit}=${secondUnitName.trim()}`
            }
            navigate(route);
        }
    }

    const deleteProject = async (e) => {
        e.preventDefault();
        const token = await getAccessTokenSilently();
        DeleteAuth(`/api/v6/admin/capacity_projects/${rowSelected.type}/${rowSelected._id}`, token)
            .then(data => {
                if (data.status === 200) {
                    setRowDeleted(data.data);
                    setShowDeleteModal(false);
                    swal({
                        title: `Project Deleted Successfully.`,
                        text: 'Project Deleted Successfully.'
                    });
                } else {
                    console.error(data);
                }
            })
            .catch(err => {
                swal({
                    title: `Error deleting the project.`,
                    text: 'Please try again later.'
                });
                console.error(err);
            })
    }

    const deleteProjectBtn = <>
        <Button
            onClick={() => {
                setShowDeleteModal(true);
            }}
            id={"upload-trash-btn"}
            disabled={!rowSelected}>
            <i className="fa fa-trash" aria-hidden="true"></i>
        </Button>
        <Modal className="warning-modal" backdrop="static" isOpen={showDeleteModal}>
            <ModalHeader toggle={() => setShowDeleteModal(false)}>Are you sure you want to delete
                the selected Project</ModalHeader>
            <ModalFooter>
                {rowSelected && <Button onClick={deleteProject} color="danger">Confirm Delete</Button>
                }
                <Button color="secondary" onClick={() => {
                    setShowDeleteModal(false)
                }}>Cancel</Button>
            </ModalFooter>
        </Modal>
    </>

    const onSelectionChanged = (gridRef) => {
        const selectedRow = gridRef?.current?.api?.getSelectedRows?.()?.[0];
        if (selectedRow) {
            setRowSelected(selectedRow);
        }
    };

    return (
        <VsiBubble>
            <Grid addStyle data={data.recordset}
                  gridText={'Double click to see capacity plan'}
                  columnDefs={colDefs}
                  rowSelection={'single'}
                  onSelectionChanged={onSelectionChanged}
                  customToolbarButton={deleteProjectBtn}
                  rowDoubleClicked={rowDoubleClicked}/>

        </VsiBubble>
    )

}
